import React from "react";
import { WriteItem, WriteHeaderItem, WritePrice, WriteHeader } from '../helper';
import '../styles.css';

export default function HairService() {
  return (
    <section className="wedding-header">
      <WriteHeader header="Bridal Hair Package" />
      <WritePrice price="£480" />
        <WriteHeaderItem description="What's included:" />
        <WriteItem description="Bride and 3 Bridemaids (travel fee included)" />
        <WriteHeaderItem description="Booking fee of £75" />
        <WriteHeaderItem description="Change of location fee of £45 (if applicable)" />

        <h5 style={{ marginTop: '30px' }}>Trials</h5>
        <WriteItem description="Bride - £85" />
        <WriteItem description="Bridemaids - £65 per person" />

        <h5 style={{ marginTop: '30px' }}>Individual prices</h5>
        <WriteItem description="Brides - £220" />
        <WriteItem description="Bridemaids - £85 per person" />
        <WriteItem description="Mother of the Bride or Groom - £60 per person" />
        <WriteItem description="Under 10s - £35 per person" />
    </section>
  );
}